export const upgradeToStyles = {
	upgradeToContainer: {
		padding: '8px',
		justifyContent: 'center',
	},
};
